
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M23.268 17.768l-2.955 2.955a.997.997 0 01-1.414 0 .999.999 0 010-1.414L21.208 17h-3.707a2.502 2.502 0 00-2.5 2.5V23a1 1 0 11-2 0v-3.5c0-2.481 2.019-4.5 4.5-4.5h3.707l-2.293-2.293a.999.999 0 111.414-1.414l2.939 2.939a2.502 2.502 0 010 3.535zM14 6c0 3.309-2.691 6-6 6S2 9.309 2 6s2.691-6 6-6 6 2.691 6 6zm-2 0c0-2.206-1.794-4-4-4S4 3.794 4 6s1.794 4 4 4 4-1.794 4-4zm-.752 8.283A9.047 9.047 0 009 14c-4.963 0-9 4.037-9 9a1 1 0 102 0c0-3.859 3.141-7 7-7 .592 0 1.181.074 1.752.221a1.001 1.001 0 00.496-1.938z"}})])
          )
        }
      }
    